
 
<!-- Popup container -->
<div *ngIf="showPopup" class="popup-container-fixed"
     (mouseenter)="onPopupMouseEnter()"
     (mouseleave)="onPopupMouseLeave()">
  <!-- Error Display -->
  <div *ngIf="error" class="alert alert-danger" role="alert">
      <strong>Error:</strong> {{ error }}
  </div>
 
  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading-overlay">
      <div class="loading-content">
          <div class="spinner" role="status" aria-live="polite"></div>
          <p>Processing...</p>
      </div>
  </div>
 
  <!-- Audio Recording -->
  <div class="card mb-1">
      <div class="card-header">
          <h5>🎙️ Record Audio</h5>
      </div>
      <div class="card-body">
          <div class="d-flex flex-wrap gap-2 mb-1">
              <button class="btn btn-primary" (click)="startRecording()" [disabled]="isRecording">
                  <span *ngIf="!isRecording">🎙️ Start Recording</span>
                  <span *ngIf="isRecording">
                      <span class="blinking-dot me-2" [class.paused]="isPaused"></span>
                      Recording... ({{ recordingSeconds }}s)
                  </span>
              </button>
              <button class="btn btn-danger" (click)="stopRecording()" [disabled]="!isRecording">⏹️ Stop</button>
              <button class="btn" [ngClass]="isPaused ? 'btn-success' : 'btn-warning'"
                      (click)="togglePauseResume()" [disabled]="!isRecording">
                  <span *ngIf="!isPaused">⏸️ Pause</span>
                  <span *ngIf="isPaused">▶️ Resume</span>
              </button>
              <button class="btn btn-primary" (click)="uploadRecording()"
                      [disabled]="!recordedBlob && !fileForUpload">
                  <span *ngIf="!isLoading">🎯 Transcribe</span>
                  <span *ngIf="isLoading">⏳ Transcribing...</span>
              </button>
          </div>
 
          <!-- Playback -->
          <div class="mt-2">
              <p class="text-success">✅ Audio recorded successfully!</p>
              <p class="text-muted">Duration: {{ recordingSeconds }}s</p>
              <audio controls [attr.src]="recordedBlobUrl"></audio>
          </div>
      </div>
  </div>
 
  <!-- File Upload -->
<div class="card mb-1">
    <div class="card-header d-flex align-items-center justify-content-between" (click)="isCollapsed = !isCollapsed"
        style="cursor: pointer;">
        <span>📁 Upload Audio</span>
        <i class="fa" [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </div>
 
 
    <div class="card-body" *ngIf="!isCollapsed">
        <div class="form-group">
              <label for="audioFile">Select Audio File</label>
              <input type="file" id="audioFile" accept="audio/*" (change)="onFileChange($event)" class="form-control">
          </div>
          <div *ngIf="fileForUpload" class="file-info mt-1">
              <p class="text-success">✅ File selected: {{ fileForUpload.name }}</p>
              <p class="text-muted">Size: {{ fileForUpload.size }} bytes</p>
          </div>
      </div>
  </div>



  